import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep';

import ActionLink from '../builder/ActionLink';
import FloatingLayerPublic from '../front/FloatingLayerPublic';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText';
import PrizeImage from '../front/PrizeImage';
import UserName from '../front/UserName';

import InfiniteScroll from '../hoc/InfiniteScroll';
import Spinner from '../builder/Spinner';

function PrizesPageItem (props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const nPage = 80;
	const prize = props.prize;
	const is_builder = props?.is_builder ?? false;

	const [ winners, setWinners ] = useState([]);
	const [ rand, setRand ] = useState(0);
	const [ viewMore, setToggle ] = useState(false);

	const [ loaded, setLoaded ] = useState(true);

	useEffect(() => {
		const display_winners = prize.display_winners && prize.display_winners == 1 ? true : false;
		if(is_builder || !display_winners || (props?.prize?.Prize ?? []).length > 0)return;
		setLoaded(!display_winners);	
	
		$.get(`/v24/winners/${props.prize.promotion_id}/${props.prize.id}`, (res) => {
			const _prize = {...prize}
			if(res.status == 1 && res?.data?.winners != undefined)_prize.Prize = (res.data.winners).map((item) => ({ name: item }));
			if(res.status == 1 && res?.data?.alternates != undefined)_prize.Alternate = (res.data.alternates).map((item) => ({ name: item }));
			setTimeout(() => {
				if(props.updatePrize != undefined)props.updatePrize(_prize);
				setLoaded(true);
			}, 300);
		}, 'JSON');
	}, []);

	useEffect(() => {
		setWinners(prize.Prize ? prize.Prize.slice(0, nPage) : []);
		setRand(Math.random()*100000);
	}, [ prize ]);

	const toggleViewMore = () => {
		setToggle(!viewMore);
	};

	/*const nextPage = (_page, cb) => {
		const page = parseInt(_page);
		cb({
			data:props.prize.Prize.slice((page - 1) * nPage, page * nPage),
			hasMore:(props.prize.Prize.length > page * nPage) ? true : false,
		});
	};*/

	const has_info = (prize.info != undefined && prize.info != '') ? true : false;

	let has_winners = ((prize?.Prize ?? []).length > 0) ? true : false;
	let hide_certificate = isNotEmpty(prize,'hide_certificate',['', '0', 0]) ? true : false;
	if(prize.assignation != '2') hide_certificate = false;
	if((prize?.Prize ?? []).length == 0) hide_certificate = false;//total Guanyadors
	if(prize.sweep_id == undefined || !prize.sweep_id) hide_certificate = false;
	if (prize.assignation == '1') hide_certificate = true;

	const public_entries = props?.public_entries ?? false;
	const max_alternates_to_display = 10;
	const _display_winners = (prize.display_winners && prize.display_winners == 1 && has_winners) ? true : false;

	return (
		<li onClick={(props.onClick != undefined) ? () => props.onClick() : null}>
			<div class="gui_ct_bg">
				<div class="prize_info gui_normal_padded_img gui_margined_children_low_v">
					<PrizeImage prize={prize} />

					<div class="prize_contents gui_main_text_color_on_bg">
						<div class="prize_texts">
							{(prize.hide_title !== true && prize.title) && (
								<h2 class="prize_title in_top" dangerouslySetInnerHTML={{ __html:prize.title.replace(/_/g, '<br />') }} />
							)}

							{(prize.description != null && prize.description != '') && (
								<p class="prize_description list_description">{prize.description}</p>
							)}
						</div>

						{(has_info) && (
							<div class="actions gui_not_in_top_small">
								<ActionLink
									onClick={toggleViewMore}
								>view more</ActionLink>
							</div>
						)}

						{(!loaded) && (
							<div class="gui_pos_rel not_in_top" style={{ minHeight:'100px' }}>
								<Spinner>Loading winners</Spinner>
							</div>
						)}

						{(_display_winners) && (
							<div class="not_in_top">
								<div class="winners_title">
									<h2 class="knk-winners">{i18n("Winners")} ({prize.Prize.length})</h2>

									{(!hide_certificate) && (
										<ActionLink
											_href={prize.certificate_link}
											_target="_blank"
										>View certificate</ActionLink>
									)}
								</div>

								<InfiniteScroll
									key={`${rand}-${prize.Prize.id}`}
									//fetch={(p, cb) => nextPage(p,cb)}
									fetched={(data) => { setWinners(winners.concat(data)) }}
									_maxHeight={{ maxHeight:'195px' }}
								>
									<ul class="gui_list_rows gui_2cols" style={{maxHeight:'100%'}}>
										{winners.map((w, i) => (
											<li key={i} class="is_user hb_secondaryFont">
												<UserName
													user={w}
													public={public_entries}
													avatar={((prize.Prize.length < 31) ? true : false)}
													linked={false}
												/>
											</li>
										))}
									</ul>
								</InfiniteScroll>
							</div>
						)}

						{/*((prize.show_alternates && prize.show_alternates == 1) && (prize.Alternate && prize.Alternate.length > 0 && prize.Alternate)) && (
							<div class="not_in_top gui_public_alternates">
								<strong class="this_block_label">{i18n("Alternate winners")} ({prize.Alternate.length}):</strong>

								<ul class="gui_list_by_comma">
									{prize.Alternate.slice(0, max_alternates_to_display).map((w, i) => (
										<li key={i} class="hb_secondaryFont">
											<UserName
												_class="gui_alternate"
												user={w}
												public={public_entries}
												display_avatar={false}
												linked={false}
											/>
										</li>
									))}
								</ul>
							</div>
						)*/}
					</div>
				</div>
			</div>

			{(has_info && viewMore) && (
				<FloatingLayerPublic
					backButton={toggleViewMore}
					title={`<h1>${i18n("Prize details")}</h1>`}
					_class={{other:'emulated_box'}}
				>
					<LeveledHTMLText>{prize.info}</LeveledHTMLText>
				</FloatingLayerPublic>
			)}
		</li>
	)
}
export default injectIntl(PrizesPageItem);